<template>
    <div :class="$style['g-foot']">
        <div class="m-container">
            <div :class="$style['container-inner']" class="flex items-center justify-between">
                <div :class="$style['state--pos-left']">
                    <div :class="$style['copyright']">
                        <span class="text"> &copy; 2024 SUPERDAO INC. </span>
                    </div>
                </div>
                <div :class="$style['state--pos-right']">
                    <button :class="$style['btn--lang']" class="flex items-center" @click="showLanguageSwitch = true">
                        <span class="text">{{showLangName()}}</span>
                        <UeIcon :class="$style['ic']" name="earth" />
                    </button>
                </div>
            </div>
        </div>
        <transition :css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">
            <!-- <SiteNavFold v-if="foldNavIsOpen" :class="$style['site-nav--fold']" :nav-list="siteNavList" :open="foldNavIsOpen" @closeFoldNav="foldNavIsOpen = false" /> -->
            <div v-show="showLanguageSwitch" :class="$style['inner']" >
                <div :class="$style['lang-switch-head']">
                    <button :class="$style['btn--close-fold-nav']" class="flex justify-center items-center" @click="closeLangModal">
                        <UeIcon :class="$style['ic']" name="x-close" />
                    </button>
                </div>
                <!-- <transition
        :css="false"
        @before-enter="beforeEnter"
        @enter="enter"
        @leave="leave"
      > -->
                <LanguageSwitch ref="LanguageSwitch" @closeLangModal="closeLangModal" :isShow="showLanguageSwitch" />
            </div>
        </transition>
    </div>
</template>
<script>
import { getLanguageList } from '@/api/user'
import { mapGetters } from 'vuex'
import { gsap } from "../../utils/gsap";
import LanguageSwitch from "./LanguageSwitch.vue";
export default {
    data() {
        return {
            langOptions: [],
            showLanguageSwitch: false,
        }
    },
    components: {
        LanguageSwitch
    },
    created() {
        this.getLanguageList()
        this.showLangName()
    },
    computed: {
        ...mapGetters(['isDirection', 'language']),
    },
    methods: {
        footerLang() {
            console.log('看看底部语言')
        },
        getLanguageList() {
            getLanguageList().then((res) => {
                this.langOptions = res.data || []
                // console.log(this.langOptions,'this.langOptions---');
                let langNameList = this.langOptions.map((option) => option.name)
                console.log(langNameList, '看看langNameList---')
            })
        },
        showLangName() {
            const languageNames = {
                en: 'English',
                ko: '한국인',
                'zh-TC': '繁體中文',
                ja: '日本語',
                ru: 'Русский',
                fa: 'فارسی',
                uk: 'українська',
                es: 'Español',
                vi: 'ViệtName',
            }

            return languageNames[this.language] || ''
        },
        closeLangModal() {
            this.showLanguageSwitch = false
        },
        beforeEnter(el) {
            gsap.set(el, { opacity: '0' })
        },
        enter(el, done) {
            console.log('进入了')
            gsap.to(el, {
                opacity: '1',
                duration: 0.36,
                onComplete: done,
            })
        },
        leave(el, done) {
            console.log('移出了')
            gsap.to(el, {
                opacity: '0',
                duration: 0.16,
                onComplete: done,
            })
        },
    },
}
</script>
<style lang="scss" module>
@import '../../assets/uemo-scss/scss/abstracts/_breakpoint.scss';
@import '../../assets/uemo-scss/scss/abstracts/_functions.scss';
@import '../../assets/uemo-scss/scss/abstracts/_mixins.scss';
.g-foot {
    color: color(var(--g--color-font--default), 0.6);
    .container-inner {
        padding: 40px 0;

        // border-top: 1px solid rgba(#dfe9fb, 0.15);
    }
    .copyright {
        font-size: 24px;
    }
    .btn--lang {
        font-size: 20px;

        padding: 12px 28px;

        border: 4px solid rgba(#fff, 0.3);
        border-radius: 100px;
        .ic {
            font-size: 26px;

            margin-left: 7px;
        }
    }
}
@include media-breakpoint-down(xxl) {
    .copyright {
        font-size: 12px;
    }
}
.site-nav--fold {
  position: fixed;
  z-index: calc(var(--g--layer--z-index--lv1) + 10);
  top: 0;
  left: 0;
}
// .inner {
//   position: fixed;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   width: 100%;
//   height: var(--g--full-height);
//   background: rgb(22, 23, 25 / 0.8);
//   box-shadow: 0 4px 6px -2px rgb(16, 24, 40 / 0.03),
//     0 12px 16px -4px rgb(16, 24, 40 / 0.08);
//   backdrop-filter: blur(25px);
//   z-index: 9999;
// }
.inner {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  bottom: 0;
  right: 0;
//   height: 100%;
//   width: 100%;
//   height: var(--g--full-height);
  background: rgb(22, 23, 25 / 0.8);
  box-shadow: 0 4px 6px -2px rgb(16, 24, 40 / 0.03),
    0 12px 16px -4px rgb(16, 24, 40 / 0.08);
  backdrop-filter: blur(25px);
   z-index: 9999;
}
.lang-switch-head {
  height: 158px;
}
.btn--close-fold-nav {
  @include square(50px);
  font-size: 45px;
  position: absolute;
  z-index: var(--g--z-index);
  color: #fff;
  top: 50px;
  right: 30px;
  transition: 0.36s ease;
  transform: translateY(var(--nav-fold--inner-y));
}
</style>



// WEBPACK FOOTER //
// src/compontents/newHome/SiteFoot.vue